const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Returns the correct avatar URL for a user/player object.
 * Checks for custom uploaded picture (picture_path) first,
 * then falls back to Google profile picture.
 */
export const getAvatarUrl = (user) => {
  if (user?.picture_path) {
    return `${API_URL}/api/files/${user.picture_path}`;
  }
  return user?.picture || null;
};
